let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("62AD8")).then(() => parcelRequire('2JGhm'));